import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDownloadUrl } from '../../functions/Api';

const Syllabus = () => {
  const { strm, classnumber } = useParams();
  const [syllabusUrl, setSyllabusUrl] = useState(null);
  const [error, setError] = useState(null);
  const apiBaseUrl = process.env.REACT_APP_API_ENDPOINT;

  useEffect(() => {
    try {
      getDownloadUrl(classnumber, strm)
        .then((result) => {
          if (result.status === 'READY') {
            setSyllabusUrl(result.downloadUrl);
          } else if (!!result.downloadUrl) {
            setSyllabusUrl(result.downloadUrl);
          } else if (result.message) {
            throw new Error(result.message);
          } else {
            throw new Error('Failed to retrieve syllabus link');
          }
        })
        .catch((err) => {
          setError(err.message);
        });
    } catch (err) {
      setError('Could not retrieve syllabus download URL.');
    }
  }, [apiBaseUrl, strm, classnumber]);

  if (error) return <p>{error}</p>;
  if (!syllabusUrl) return <p>Getting syllabus...</p>;
  return (
    <div>
      <p>
        This syllabus is to be used as a guideline only. The information
        provided is a summary of topics to be covered in the class. Information
        contained in this document such as assignments, grading scales, due
        dates, office hours, required books and materials may be from a previous
        semester and are subject to change. Please refer to your instructor for
        the most recent version of the syllabus
      </p>
      <a href={syllabusUrl}>View Syllabus</a>
    </div>
  );
};

export default Syllabus;
